module.exports = __webpack_public_path__ + "static/img/2.f071fba5.jpg";